import { render } from "./footer.vue?vue&type=template&id=52fd024b"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=52fd024b&lang=scss&scope=true"

import exportComponent from "D:\\nbjgjxh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__